import { IPatternSegment } from "./IPatternSegment";
import { RouteParam } from "./IRoute";

export class RoutePartPatternSegment implements IPatternSegment {
    readonly isVariable = true;

    constructor(private readonly patternPart: RouteParam) {}

    get name() {
        return this.patternPart.param.substring(1);
    }

    match(pathPart: string): boolean {
        const { matches = () => true } = this.patternPart;
        return matches(pathPart);
    }
}
